import { Injectable } from '@angular/core';
import { ServiceService } from '../service.service';

@Injectable({
  providedIn: 'root'
})
export class PqrsService {

  constructor(private servi: ServiceService) { }

  getServe() { return this.servi.server; }

  getRecursos() { return this.servi.get_p("/PublicCOGUI/getRecursosPQRS"); }

  guardar(data) {
    var formData = new FormData();
    for ( var nombre in data ) {
       if (data[nombre]) {
         if(nombre == "archivos"){
              for(var i=0; i<data.archivos.length; i++){
                formData.append("archivos[]", data.archivos[i]);
              }
         } else {
          formData.append(nombre, data[nombre]);
         }
       }
    }
    return this.servi.postFile('/PublicCOGUI/guardarSolicitudPQRS', formData);
  }

  consultarPQRS(id) { return this.servi.get_p('PublicCOGUI/BuscarPqrs/' + id ); }
  
  buscarDoc(documento,typeDocument){debugger; return this.servi.get_p('PublicCOGUI/BuscarPersona?tipoDoc='+ typeDocument+'&&doc='+documento);}


  EstadoEncuestaPQRS(id) { return this.servi.post_p('PublicCOGUI/EstadoEncuestaPQRS', {id:id} ); }

  guardarEncuesta(data) { 
    return this.servi.post('/PublicCOGUI/guardarEncuesta', data);
  }

  getInfoIp() { return this.servi.getResourceLocal("https://ipinfo.io/?token=ac0aed50ae3667").toPromise(); }

}

